// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logo.png";
import AboutUs from "layouts/pages/landing-pages/about-us";
import ProductDesign from "layouts/pages/landing-pages/product-design";
import WebDesign from "layouts/pages/landing-pages/web-development-maintenance";
import RemoteSupport from "layouts/pages/landing-pages/remote-desktop-support";
import CyberSecurity from "layouts/pages/landing-pages/cyber-security";
import ContactUs from "layouts/pages/landing-pages/contact-us";
import MobileAppDevelopemt from "layouts/pages/landing-pages/mobile-app-developemt-mantainance";
import ML from "layouts/pages/landing-pages/machine-learning";
import AI from "layouts/pages/landing-pages/artificial-intelligence";
import GENAI from "layouts/pages/landing-pages/generative-ai";
import DiGMar from "layouts/pages/landing-pages/digital-marketing";
import TTs from "layouts/pages/landing-pages/terms-conditions";
import PPs from "layouts/pages/landing-pages/privacy-policy";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "HP TECH SOLUTIONS",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/CreativeTim/",
    },
    {
      icon: <TwitterIcon />,
      link: "https://twitter.com/creativetim",
    },
    {
      icon: <GitHubIcon />,
      link: "https://github.com/creativetimofficial",
    },
    {
      icon: <YouTubeIcon />,
      link: "https://www.youtube.com/channel/UCVyTG4sCw-rOvB9oHkzZD1w",
    }
  ],
  menus: [
    {
      name: "Company",
      items: [
        {
          name: "about us",
                  route: "/pages/landing-pages/about-us",
                  component: <AboutUs />,
        },
        {
          name: "Contact Us",
                  route: "/pages/landing-pages/contact-us",
                  component: <ContactUs />,
        },
      ],
    },
    {
      name: "Development Services",
      items: [
            {
              name: "Product Design",
              route: "/pages/landing-pages/product-design",
              component: <ProductDesign />,
            },
            {
              name: "Web Development & Maintenance",
              route: "/pages/landing-pages/web-development-maintenance",
              component: <WebDesign />,
            },
            {
              name: "Mobile App Developemt",
              route: "/pages/landing-pages/mobile-app-developemt-mantainance",
              component: <MobileAppDevelopemt />,
            },
            
            
            
          ],
    },
    {
      name: "Other services and Support",
      items: [
        {
          name: "Remote Desktop Support",
          route: "/pages/landing-pages/remote-desktop-support",
          component: <RemoteSupport />,
        },
        {
          name: "Cyber Security",
          route: "/pages/landing-pages/cyber-security",
          component: <CyberSecurity />,
        },
        {
          name: "Digital Marketing",
          route: "/pages/landing-pages/digital-marketing",
          component: <DiGMar />,
        },
        {
          name: "Machine Learning (ML)",
          route: "/pages/landing-pages/machine-learning",
          component: <ML />,
        },
        {
          name: "Artificial Intelligence (AI)",
          route: "/pages/landing-pages/artificial-intelligence",
          component: <AI />,
        },
        {
          name: "Generative AI (GenAI)",
          route: "/pages/landing-pages/generative-ai",
          component: <GENAI />,
        },
      ],
    },
    {
      name: "legal",
      items: [
        { 
          name: "terms & conditions", 
          route: "/pages/landing-pages/terms-conditions",
          component: <TTs />,
        },
        { 
          name: "privacy policy", 
          route: "/pages/landing-pages/privacy-policy",
          component: <PPs />,
        }
      ],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      All rights reserved. Copyright &copy; {date} Hp Tech Solutions
    </MKTypography>
  ),
};
